import styled from "styled-components";

export const AlertsSection = styled.section`
  width: 100%;
  margin-top: 0.25rem;
  border: 1px solid var(--border-default);
  border-radius: 14px;
  background: var(--surface-1);
  padding: 1.15rem 1.25rem 1.35rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem 0.9rem 1.15rem;
    border-radius: 12px;
  }
`;

export const AlertsSectionHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.65rem;
`;

export const AlertsSectionTitle = styled.h2`
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--accent);
`;

export const AlertsCount = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
`;

export const AlertsActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.85rem;
`;

export const AlertsEmpty = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: var(--text-secondary);
  line-height: 1.45;
  padding: 0.35rem 0 0.15rem;
`;

export const AlertsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
`;

export const AlertCard = styled.article`
  padding: 0.95rem 1rem 1.05rem;
  border-radius: 12px;
  background: var(--surface-2);
  border: 1px solid var(--border-default);
`;

export const AlertCardHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.55rem;
  margin-bottom: 0.75rem;
`;

export const AlertCode = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font: inherit;
  font-size: 1.02rem;
  font-weight: 700;
  color: var(--accent);
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;

export const AlertBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border: 1px solid
    ${({ $tone }) =>
      $tone === "danger"
        ? "var(--danger)"
        : $tone === "warn"
          ? "var(--warning, #d4a017)"
          : $tone === "ok"
            ? "var(--accent)"
            : "var(--border-default)"};
  color: ${({ $tone }) =>
    $tone === "danger"
      ? "var(--danger)"
      : $tone === "warn"
        ? "var(--warning, #d4a017)"
        : $tone === "ok"
          ? "var(--accent)"
          : "var(--text-secondary)"};
  background: ${({ $tone }) =>
    $tone === "danger"
      ? "color-mix(in srgb, var(--danger) 14%, transparent)"
      : $tone === "warn"
        ? "color-mix(in srgb, var(--warning, #d4a017) 14%, transparent)"
        : $tone === "ok"
          ? "var(--accent-soft)"
          : "var(--surface-1)"};
`;

export const AlertMetaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem 1rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const AlertMetaItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;

  &[data-full="true"] {
    grid-column: 1 / -1;
  }
`;

export const AlertMetaLabel = styled.span`
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary);
`;

export const AlertMetaValue = styled.p`
  margin: 0;
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.4;
  word-break: break-word;
`;

export const AlertObs = styled.p`
  margin: 0.15rem 0 0;
  font-size: 0.88rem;
  font-weight: 500;
  color: var(--text-secondary);
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const TicketsBlock = styled.div`
  margin-top: 0.85rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--border-default);
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
`;

export const TicketItem = styled.div`
  padding: 0.55rem 0.65rem;
  border-radius: 8px;
  background: var(--surface-1);
  border: 1px solid var(--border-default);
  font-size: 0.85rem;
  color: var(--text-secondary);
  line-height: 1.4;

  strong {
    color: var(--text-primary);
    font-weight: 650;
  }
`;

export const TicketPhotos = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-top: 0.45rem;
`;

export const TicketPhoto = styled.a`
  display: block;
  width: 64px;
  height: 64px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border-default);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;
